import n, { createContext as r, useContext as i } from "react";
var e = r(void 0);

function a() {
  return i(e);
}

function l(_ref) {
  var t = _ref.value,
      o = _ref.children;
  return n.createElement(e.Provider, {
    value: t
  }, o);
}

export { l as DisabledProvider, a as useDisabled };